import { Form, Formik } from 'formik';
import React, { Component } from 'react';
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { userid, currentTenant } from '../../Common/Credentials.js';
import Footer from '../../Component/Footer.js';
import Header from '../../Component/Header.js';
import Menu from '../../Component/Menu.js';
import { FormikTextField } from '../../CommonComponents/FormField.js';
import TaxServices from './TaxServices.js';
import { Spinner } from 'react-bootstrap';


class AddTax extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tax: '',
      message: '',
      loader: false,
      type: false
    }
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  onSubmit() {
    this.setState({ loader: true })
    let data = {
      tax: this.state.tax,
      tenantid: currentTenant
    }
    TaxServices.addTax(data).then(() =>
      this.props.navigate('/taxes'))
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
        this.setState({ message: e.response.data.message, loader: false })
      })

  }

  componentDidMount() {

    if (userid === undefined) {
      window.confirm('Your Session is Lost: Please login Back to resume')
      this.props.navigate(`/`)
    }

  }


  validate(values) {

    let errors = {}

    if (!values.tax || values.tax === '') {
      errors.tax = "Tax is Required";
    }
    return errors;
  }

  render() {
    let { id, tax } = this.state;

    return (

      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className="card">
            <ol className="breadcrumb float-sm-right">
              <li className=" text-secondary">
                <Link
                  as="button"
                  className=" text-secondary"
                  to={{ pathname: "/taxes" }} state={{ message: "" }}
                >
                  ❮ Back &nbsp;&nbsp;
                </Link>
              </li>
              <li className="breadcrumb-item text-secondary">
                <Link to="/masters">Home</Link>
              </li>
              <li className="breadcrumb-item text-secondary">
                <Link to="/taxes">Tax</Link>
              </li>
              <li className="breadcrumb-item active">Add Tax</li>
            </ol>
            <div className="card-body">

              <Formik
                initialValues={{ id, tax }}
                onSubmit={this.onSubmit}
                validateOnChange={false}
                validate={this.validate}
                enableReinitialize={true}>
                {() => (
                  <Form autoComplete="off">
                    <div className="form-row">

                      <fieldset className="form-group col-md-3">
                        <FormikTextField className="form-control" type="text" name="tax" label="Tax(%)" value={this.state.tax} onChange={(e) => this.setState({ tax: e.target.value, message: '' })} />
                      </fieldset>
                    </div>
                    <div className="form-group col-md-12 text-red">{this.state.message}</div>
                    {this.state.loader === true ? <button className="UI-btn UI-btn-primary tw-mr-2" disabled><Spinner animation="border" size="sm" />&nbsp;{"Saving"}</button> : <button className="UI-btn UI-btn-primary tw-mr-2" type="submit">Save</button>}
                    <Link as="button" className="UI-btn UI-btn-outline" to={{ pathname: '/taxes' }} >Cancel</Link>

                  </Form>
                )}
              </Formik>

            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
export default withRouter(AddTax)